import * as React from 'react';
import './style.scss'

export default class Bottom extends React.Component<any> {

  public openUrlMobile(index: number) {
    switch (index) {
      case 1:
        window.location.href = 'http://sq.ccm.gov.cn:80/ccnt/sczr/service/business/emark/toDetail/4429A274B7C54AB5A776F54614AB8CE1'
        break;
      case 2:
        window.location.href = 'http://sq.ccm.gov.cn:80/ccnt/sczr/service/business/emark/gameNetTag/4028c08b58bd467b01594e886e64013b'
        break;
      case 3:
        window.location.href = 'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502013348'
      case 4:
        window.open('https://beian.miit.gov.cn/#/Integrated/index', '_blank')
      default:
        break;
    }
  }
  public render() {
    return (
      <div className="mobile-bottom">
        <div className="copy-right">
          <p>健康游戏忠告：抵制不良游戏 拒绝盗版游戏 注意自我保护 谨防受骗上当</p>
          <p>适度游戏益脑 沉迷游戏伤身 合理安排时间 享受健康生活</p>
          <p onClick={this.openUrlMobile.bind(this, 4)}>网站备案号：沪ICP备14010092号-6</p>
          <p>本平台游戏适合18岁以上人群</p>
          <p>上海域起网络科技有限公司</p>
          <p>公司地址：中国（上海）自由贸易试验区芳春路400号1幢3层</p>
          <p>公司电话：021-50129861</p>
          {/* <p className="two-img">
            <img src={require("@static/wenhuajingying.png")} onClick={this.openUrlMobile.bind(this, 1)} alt="域起官网"/>
            <img src={require("@static/youxidzbq.png")} onClick={this.openUrlMobile.bind(this, 2)} alt="域起官网"/>
          </p> */}
          <p className="wen" onClick={this.openUrlMobile.bind(this, 1)}>许可证号: 沪网文〔2017〕1616-058号</p>
          <p className="g" onClick={this.openUrlMobile.bind(this, 2)}>备案文号: 文网游备字〔2017〕Ｍ-CBG 0125 号</p>
          <p className="beian" onClick={this.openUrlMobile.bind(this, 3)}>沪公网安备 31011502013348号</p>
          <p className="cursor hubianhao">沪B2-20140044</p>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Mobile/Bottom/index.tsx